<template>
  <div class="folder-card" :style="{ animationDelay: animationDelay, animation: 'fadeInUp 0.5s ease forwards' }">
    <draggable :options="{ delay: dragDelay }" :key="`draggable-${folder.id}`">
      <v-layout
      class="item justify-start align-center"
      :class="[folderNotReceivedClass(folder), {'dragging': folder.id === draggingItemId}]"
      @click.stop="openFolder(folder.id)"
      justify-start
      align-start
      row
      wrap
      @dragstart="startDrag(folder.id)"
      @dragend="setDraggingItem(null)"
      @mousedown="startTimer(folder.id)"
      @mouseup="stopTimer"
      @mouseleave="stopTimer"
      :style="{
        borderLeft: '6px solid ' + getFolderTypeColor(folder.folder_type),
        boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
      }"
    >
      <v-tooltip bottom max-width="300" >
        <template #activator="{ on }">
          <v-flex v-on="on" class="pa-1 d-inline-flex align-center folder-icon-col" xs1 xl1>
            <v-icon :size="40" style="color: #dcb03c !important;"
                    :color="folder.current_owner && user && folder.current_owner.id === user.id ? 'primary' : 'grey'">
              {{ folder.current_owner && user && folder.current_owner.id === user.id ? 'mdi-folder-open' : 'mdi-folder' }}
            </v-icon>
            <!-- Status Badge - Somente mostrado quando necessário -->
          </v-flex>
          <v-flex class="order-col text-left align-center" xs1 xl1 style="max-width: 4%; flex-basis: 4%;">
            <!-- Status Badge - Movido para fora da coluna e posicionado absolutamente -->
            <div class="align-center" v-if="folder.received_status || folder.pending_type">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <div  v-on="on">
                    <v-icon class="status-icon received" v-if="folder.received_status === 'Recebido'">mdi-check</v-icon>
                    <v-icon class="status-icon waiting"  v-else-if="folder.received_status === 'Não Recebido'">mdi-clock-outline</v-icon>
                    <v-icon class="status-icon refused"  v-else-if="folder.received_status === 'Recusado'">mdi-rotate-left</v-icon>
                    <v-icon class="status-icon pending"  v-else-if="folder.pending_type">mdi-alert-circle-outline</v-icon>
                  </div>
                </template>
                <span>
              {{ folder.pending_type ? `${getFolderPendingTypeLabel(folder)} Pendente` : (folder.received_status || 'Não Recebido') }}
            </span>
              </v-tooltip>
            </div>
          </v-flex>
          <!-- Processo -->
          <v-flex v-on="on" class="processo-container text-left" xs3 xl3 style="min-width: 0;">
            <div class="processo-layout" @click.stop>
              <div class="processo-content">
                <div class="processo-cabecalho">
                  <div class="folder-type-name"
                       :style="{ color: getFolderTypeColor(folder.folder_type), fontWeight: 500 }">
                    <span>{{ truncateName(folder.folder_type.name, {length: 100}) }}</span>
                  </div>
                </div>
                <div class="processo-rodape">
                  <div class="process-number-container">
                    <span :style="{ color: getFolderTypeColor(folder.folder_type), fontWeight: 500 }">
                      {{ folder.process_number }}
                    </span>
                    <v-btn icon small class="copy-button ml-2" @click.stop="copyToClipboard(folder.process_number)">
                      <v-icon small>mdi-content-copy</v-icon>
                    </v-btn>
                  </div>
                  <v-chip
                      v-if="folder.created_in"
                      x-small
                      color="transparent"
                      class="admin-unit-badge admin-unit-badge--main mt-1"
                      :style="{
                          color: getAdminUnitColor(folder.created_in),
                          borderColor: getAdminUnitColor(folder.created_in),
                          boxShadow: '0 1px 4px rgba(0,0,0,0.10)',
                          padding: '4px 12px',
                          fontWeight: 600
                        }"
                  >
                    {{ folder.created_in.abbreviation || folder.created_in.name }}
                  </v-chip>
                </div>
              </div>
            </div>
          </v-flex>

          <v-flex class="text-left align-center px-3" xs2 xl2>
            <div class="entity-info">
              <v-tooltip bottom max-width="500">
                <template v-slot:activator="{ on }">
                  <v-chip class="entity-chip grey lighten-2" v-on="on">
                    <v-avatar size="24" class="mr-1">
                      <v-icon size="16" color="grey">mdi-briefcase</v-icon>
                    </v-avatar>
                    <span class="entity-name">{{ truncateName(folder.entity.name) }}</span>
                  </v-chip>
                </template>
                <span class="entity-name">{{ folder.entity.name }}</span>
              </v-tooltip>
            </div>
          </v-flex>

          <v-flex class="pa-2" xs3 xl3 style="min-width: 10%">
            <v-layout justify-center>
              <current-owner :folder="folder"/>
            </v-layout>
          </v-flex>

          <!-- Criado -->
          <v-flex class="text-left px-3" style="max-width: 18%; flex-basis: 18%;" xs2 xl2>
            <v-layout justify-start align-center>
              <v-chip>
            <span class="grey--text text--darken-2 text-truncate">
              <term-component :folder="folder"></term-component>
            </span>
              </v-chip>
            </v-layout>
          </v-flex>

          <span class="folder-border"></span>
        </template>
        <div class="tooltip-content" v-if="folder.subject">
          <p>{{ folder.subject }}</p>
        </div>
      </v-tooltip>

    </v-layout>
    </draggable>

  </div>
</template>

<script>
import {isEmpty, truncate} from 'lodash';
import CurrentOwner from '@/components/inbox/CurrentOwner';
import TermComponent from '@/components/inbox/TermComponent';
import {mapGetters} from 'vuex';
import adminUnitHandling from '@/mixins/admin-unit-handling';
import getColorByText from '@/assets/utils/colorByText';
import draggable from "vuedraggable";
import {mapFolderMethods} from "../../mixins/folder-status";

export default {
  name: 'FolderCard',
  components: {
    draggable,
    CurrentOwner,
    TermComponent,
  },
  mixins: [adminUnitHandling],
  props: {
    folder: {
      type: Object,
      required: true
    },
    draggingItemId: {
      type: [Number, String, null],
      default: null
    },
    viewMode: {
      type: String,
      default: 'list', // 'list' ou 'grid'
      validator: value => ['list', 'grid'].includes(value)
    },
    animationDelay: {
      type: String,
      default: '0s'
    }
  },
  data() {
    return {
      isEmpty,
      timer: null,
      dragDelay: 1000, // Tempo em milissegundos para iniciar o drag
    };
  },
  computed: {
    ...mapGetters(['user'])
  },
  methods: {
    ...mapFolderMethods,
    getAdminUnitColor(unit) {
      if (!unit) return '#000000';
      return getColorByText(unit.name);
    },
    startDrag(id) {
      this.$store.commit('setDraggingFolder', id);
      this.$emit('drag-start', id);
    },
    startTimer(id) {
      this.timer = setTimeout(() => {
        this.setDraggingItem(id);
      }, this.dragDelay);
    },
    stopTimer() {
      clearTimeout(this.timer);
      this.setDraggingItem(null);
    },
    setDraggingItem(id) {
      this.$emit('update:draggingItemId', id);
    },
    folderNotReceivedClass(folder) {
      if (folder.current_owner && this.user && folder.current_owner.id === this.user.id) {
        return 'received-folder';
      }
      return '';
    },
    folderIcon(folder) {
      if (folder.current_owner && this.user && folder.current_owner.id === this.user.id) {
        return '/static/images/folder/folder-open-icon.svg';
      }
      return '/static/images/folder/folder-closed-icon.svg';
    },
    openFolder(id) {
      this.$emit('open-folder', id);
    },
    truncateName(text) {
      if (this.$vuetify.breakpoint.lgOnly) {
        return truncate(text, {length: 40});
      }
      if (this.$vuetify.breakpoint.xlOnly) {
        return truncate(text, {length: 50});
      }
      return truncate(text, {length: 15});
    },
    getFolderTypeColor(folderType) {
      if (!folderType) return '#000000';
      return getColorByText(folderType.name);
    },
    copyToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        this.$store.dispatch('toggleSnackbar', {
          show: true,
          timeout: 2000,
          color: 'success',
          message: 'Processo copiado para a área de transferência',
          messageIcon: 'mdi-check',
        });
      }).catch(() => {
        this.$store.dispatch('toggleSnackbar', {
          show: true,
          timeout: 2000,
          color: 'error',
          message: 'Erro ao copiar o Processo',
          messageIcon: 'mdi-close',
        });
      });
    },
  }
};
</script>

<style scoped lang="scss">
/* Estilos gerais do card */
.folder-card {
  margin-bottom: 8px;
  will-change: transform, opacity;
  transform: translateZ(0);
  backface-visibility: hidden;
  opacity: 0;
  animation: fadeInUp 0.5s cubic-bezier(0.4, 0, 0.2, 1) forwards;
  animation-delay: var(--cascade-delay, 0s);

  .item {
    position: relative;
    cursor: pointer;
    border-bottom: 1px solid #e0e0e0;
    transition: all 0.2s ease-in-out;
    will-change: background-color, transform;
    overflow: hidden;
    border-radius: 3px;
    background: #fff;
    min-height: 28px;
    box-sizing: border-box;
    padding: 2px;
    font-size: 12px;
    line-height: 1.2;
    margin-bottom: 2px;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
      background-color: #f9fafc;
    }

    &.received-folder {
      background: #f2f2f2;
      font-weight: 600 !important;

      &.caption {
        font-weight: 600 !important;
      }
    }

    &.dragging {
      background-color: #005ece;
      color: white;
      transform: scale(1.02);
      box-shadow: 0 8px 16px rgba(0, 94, 206, 0.2);
    }
  }
}

.processo-content {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  cursor: default !important;
  font-size: 14px !important;

  .processo-cabecalho {
    display: flex;
    flex-direction: row;
    width: 90%;
    cursor: default !important;

    .folder-type-name {
      margin-top: 0;
      max-width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 1.3; /* Aumentado o line-height */
      cursor: default !important;
    }
  }

  .processo-rodape {
    width: 100%;
    margin-top: 6px; /* Aumentado a margem superior */
    cursor: default !important;

    /* Espaçamento entre elementos no rodapé */
    .process-number-container {
      margin-bottom: 8px; /* Adicionado margem inferior */
    }

    .admin-unit-badge {
      margin-top: 8px !important; /* Aumentado a margem superior do badge */
    }
  }
}

/* Estilos para o contêiner de processo (semelhante ao documento-container) */
.processo-container {
  display: flex;
  flex-direction: column;
  padding: 8px 10px; /* Aumentado o padding */
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
  cursor: default !important;
  font-size: 14px;

  .process-number-container {
    display: flex;
    align-items: center;
    height: 16px;

    span {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: block;
      cursor: default !important;
    }

    .copy-button {
      //margin-top: -2px !important;
      //height: 16px !important;
      //width: 16px !important;
      cursor: pointer !important;

      //&:hover {
      //  background-color: rgba(0, 0, 0, 0.05);
      //}

      .v-icon {
        color: #757575;
        cursor: pointer !important;
      }
    }
  }
}


///* Ajuste na coluna de status */
//.status-badge-container {
//  position: absolute;
//  top: 4px;
//  left: 4px;
//}
//
///* Ajuste na coluna de status */
//.status-badge-container {
//  position: absolute;
//  top: 4px;
//  left: 4px;
//}

/* Estilo para o container do badge */
//.status-badge-container {
//  position: absolute;
//  top: 4px;
//  right: 4px;
//}

/* Estilo aprimorado para o badge circular */
.status-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  font-size: 11px;
  font-weight: 600;
  will-change: transform;
  transform: translateZ(0);
  backface-visibility: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  border: 1px solid;
  overflow: hidden;
}

.status-icon {
  font-size: 20px;
}

/* Variantes de cores para os diferentes estados */
.received {
  color: #2e7d32;
}

.waiting {
  color: #ce9030;
}

.refused {
  color: #f87272;
}

.pending {
  color: #1565c0;
}

/* Ajuste para o ícone dentro do badge */
.status-badge .v-icon {
  font-size: 16px !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
  height: 16px !important;
  width: 16px !important;
  margin-left: 1px !important;
}


.entity-info {
  width: 90%;

  .entity-chip {
    height: auto;
    padding: 4px 8px;
    cursor: pointer;
    background-color: #f5f5f5;
    display: flex;
    align-items: center;
    width: 100%;
    transition: all 0.3s ease;
    will-change: transform;

    .v-avatar {
      flex: 0 0 auto;
      margin-right: 4px;
      transition: transform 0.3s ease;
    }

    .entity-name {
      max-width: 250px !important;
      white-space: nowrap !important;
      overflow: hidden !important;
      text-overflow: ellipsis !important;
      -webkit-line-clamp: 2 !important;
      -webkit-box-orient: vertical !important;
    }
  }
}

/* Ordem */
.order-col {
  display: flex;
  align-items: center;
}

/* Tooltip estilo igual ao DocumentList */
.tooltip-content {
  text-align: left;

  p {
    margin: 4px 0;
    font-size: 12px;
    line-height: 1.4;
  }

  strong {
    font-weight: 600;
    color: #e8dada;
  }
}

/* Estilos compartilhados */
.px-3 {
  padding: 6px 6px !important;
}

/* Responsividade - adaptado do DocumentList */
@media (min-width: 961px) and (max-width: 1264px) {
  .folder-card .item {
    flex-wrap: wrap !important;

    /* Ajuste das larguras no card para corresponder ao cabeçalho */
    .order-col {
      max-width: 8% !important;
      flex-basis: 8% !important;
    }

    .processo-container {
      max-width: 45% !important;
      flex-basis: 45% !important;
    }

    .align-center[style*="max-width: 22%"] {
      max-width: 47% !important;
      flex-basis: 47% !important;
    }

    .align-center[style*="max-width: 17%"],
    .align-center[style*="max-width: 18%"] {
      max-width: 50% !important;
      flex-basis: 50% !important;
    }
  }

  /* Ajuste para o segundo "row" das colunas */
  .folder-card .item .align-center[style*="max-width: 17%"],
  .folder-card .item .align-center[style*="max-width: 18%"] {
    margin-top: 4px;
  }
}


/* Para telas pequenas, reorganizar completamente o layout */
@media (max-width: 960px) {
  .folder-card .item {
    flex-direction: column !important;

    & > * {
      max-width: 100% !important;
      flex-basis: 100% !important;
      margin-bottom: 4px;
    }

    .order-col {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .processo-container {
      order: 0;
    }

    .order-col {
      order: -1;
    }
  }
}

@keyframes ripple {
  to {
    transform: scale(4);
    opacity: 0;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}


// Adiciona efeito de ripple personalizado
.v-ripple__container {
  opacity: 0.1;
  background-color: currentColor;
  border-radius: 50%;
  transform: scale(0);
  animation: ripple 0.6s ease-out;
}

.fade-cascade-enter-active {
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: 1;
  transform: translateY(0);
}

.fade-cascade-enter {
  opacity: 0;
  transform: translateY(20px);
}

.fade-cascade-enter-to {
  opacity: 1;
  transform: translateY(0);
}

.cascade-group > * {
  transition-delay: var(--cascade-delay, 0s);
  opacity: 1;
}

.admin-unit-badge {
  font-size: 11px !important;
  padding: 10px 8px !important;
  height: 18px !important;
  min-height: 18px !important;
  text-transform: uppercase !important;
}
</style>



// WEBPACK FOOTER //
// src/components/folder/FolderCard.vue